import React from "react";
import { useRouteError } from "react-router-dom";
import Content from "../components/content/content";
import Root from "./navigation";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id='error-page'>
      <Root />
      <Content>
        <h1>Oops!</h1>
        <p>Sorry, an unexpected error has occurred.</p>
        <p>
          <i>{(error as any).statusText || (error as any).message}</i>
        </p>
      </Content>
    </div>
  );
}
